import React from "react";

import "./index.less";

/**
 * 项目级骨架块
 *
 * - 宽高、圆角、背景色由调用方传入；
 * - 流光效果由组件统一控制，默认开启，可通过 wave={false} 关闭；
 * - 宽高/圆角支持 number（按 px）或 CSS 字符串。
 *
 * @param {number|string} width 宽度，默认 100%
 * @param {number|string} height 高度，默认 16
 * @param {number|string} borderRadius 圆角，默认 4
 * @param {string} backgroundColor 背景色，默认 #f5f5f5
 * @param {boolean} wave 是否开启流光，默认 true
 * @param {string} className 额外类名
 * @param {Object} style 额外样式
 */
export default function Skeleton({
  width = "100%",
  height = 16,
  borderRadius = 4,
  backgroundColor = "#f5f5f5",
  wave = true,
  className = "",
  style,
  ...rest
}) {
  const rootClassName = [
    "skeleton",
    wave ? "skeleton--wave" : "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={rootClassName}
      style={{ width, height, borderRadius, backgroundColor, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}
